import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { IS_PRODUCTION } from '../constants';

import { initDatadogIframeBridge } from './iframeBridge';

const env = process.env.REACT_APP_CURRENT_ENVIRONMENT || 'prod';
const version = process.env.REACT_APP_VERSION
  ? `${env}-${process.env.REACT_APP_VERSION}`
  : env;

export function initDatadogConfig() {
  if (IS_PRODUCTION) {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || '',
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.com',
      service: 'services-ne-app-front',
      env,
      version,
      sessionSampleRate: 5,
      sessionReplaySampleRate: 5,
      defaultPrivacyLevel: 'mask-user-input',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      allowFallbackToLocalStorage: true,
      allowedTracingUrls: process.env.REACT_APP_API_URL
        ? [process.env.REACT_APP_API_URL]
        : [],
      traceSampleRate: 100
    });

    datadogLogs.init({
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.com',
      service: 'services-ne-app-front',
      env,
      version,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100
    });

    initDatadogIframeBridge();
  }
}

export function setDatadogUser(user: {
  id: string | number;
  name?: string;
  plan?: string;
}) {
  datadogRum.setUser({
    id: String(user.id),
    name: user.name,
    plan: user.plan
  });
}

initDatadogConfig();
